<template>
  <img
    :class="{'pressable': linkToCustomer}"
    :src="avatarUri"
    :style="{
      width: size + 'px',
      height: size + 'px',
      borderRadius: size + 'px'
    }"
    @click="handleClick"
    alt=""
  />
</template>

<script>
import Spacings from '../enums/Spacings';

export default {
  name: "CustomerAvatar.vue",
  props: {
    size: {
      type: Number,
      required: false,
      default: Spacings.lg
    },
    customerId: {
      type: [String, Number],
      required: true
    },
    linkToCustomer:{
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    handleClick(){
      if ( this.linkToCustomer ) this.navigator.openPath(this.customerDashboardURI);
    }
  },
  computed: {
    avatarUri () {
      return '/customer/' + this.customerId + '/avatar'
    },
    customerDashboardURI () {
      return '/customer/' + this.customerId + '/dashboard'
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.avatar-and-name {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: $spacing-xs;
}
</style>
